import { useEffect } from "react";

// Injects a JSON-LD structured-data script tag into <head> for SEO.
export default function JsonLd({ data, id = "jsonld" }) {
  useEffect(() => {
    const existing = document.getElementById(id);
    if (existing) existing.remove();
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [data, id]);
  return null;
}
